import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { IResponseAPIObjeto } from "@models/responseAPI.interface";
import { ApiService } from "@services/api.service";
import { ErrorService } from "@services/error.service";
import { DangerError } from "@shared/errors/custom.error";
import { rutSinDV } from "@shared/utils/rutParser.utils";

@Component({
  selector: "app-ingreso",
  templateUrl: "./ingreso.component.html",
  styleUrls: ["./ingreso.component.css"],
})
export class IngresoComponent {
  constructor(
    private router: Router,
    private apiService: ApiService,
    private errorService: ErrorService
  ) {}
  loading = false;
  rut: string;
  showSessionConflict = false;

  async iniciarSesion() {
    this.loading = true;
    this.showSessionConflict = false;
    try {
      if (!this.rut) throw new DangerError("Debe ingresar un rut");
      const run = rutSinDV(this.rut);
      const { data, msg, success } =
        await this.apiService.privatePost<IResponseAPIObjeto>('ingreso', {
          run,
        });
      if (!success) {
        if (this.esSesionActiva(msg)) {
          this.showSessionConflict = true;
          return;
        }
        throw new DangerError(msg);
      }
      this.router.navigate(["/login/callback"], {
        queryParams: { uuid: data.uuid },
      });
    } catch (error) {
      // HTTP 400: Angular lanza excepción, el body queda en error.error
      const body = error?.error;
      const errorMsg = typeof body === 'string'
        ? body
        : (body?.msg || error?.message || '');
      if (this.esSesionActiva(errorMsg)) {
        this.showSessionConflict = true;
        return;
      }
      this.errorService.handle(error, "Error al iniciar sesión");
    } finally {
      this.loading = false;
    }
  }

  private esSesionActiva(msg: string): boolean {
    if (!msg) return false;
    const lower = msg.normalize('NFC').toLowerCase();
    return lower.includes("sesión activa") || lower.includes("sesion activa");
  }

}
